import { PermissionNameEnum } from '@Types/permissions';
import Administrator from '.';
const administratorRouter = [
  {
    path: '/administration/*',
    element: Administrator,
    name: 'side.group.administrator',
    permission: PermissionNameEnum.administrator,
  },
];

export default administratorRouter;
